import * as CommentActionTypes from '../../../constants/comments/CommentActionTypes';

const initialState = {
    activatedId: -1,
    changeStatusActivationId : -1
};

export default (state = initialState, action) => {
    switch (action.type) {
        case CommentActionTypes.CLEAR_ITEMS:
            return {
                activatedId: -1,
                changeStatusActivationId : -1
            };
        case CommentActionTypes.TOGGLE_MORE_BUTTON:
            if(action.itemId === state.activatedId){
                return Object.assign({}, state, {
                    activatedId: -1
                });
            }else{
                return Object.assign({}, state, {
                    activatedId: action.itemId,
                    changeStatusActivationId: -1,
                });
            }
        case CommentActionTypes.TOGGLE_CHANGE_STATUS_BUTTON:
            if(action.itemId === state.changeStatusActivationId){
                return Object.assign({}, state, {
                    changeStatusActivationId: -1
                });
            }else{
                return Object.assign({}, state, {
                    changeStatusActivationId: action.itemId,
                    activatedId: -1,
                });
            }
    }
    return state
}
